/* eslint-disable import/default */

import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import configureStore, { history } from './store/configureStore';
import Root from './components/Root';
//import './styles/styles.scss'; // Yep, that's right. You can import SASS/CSS files too! Webpack will run the associated loader and plug this into the page.
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/scss/font-awesome.scss"
import "./assets/css/animate.min.css";
import "./assets/sass/light-bootstrap-dashboard.css";
import "./assets/css/pe-icon-7-stroke.css";
import "./assets/css/demo.css";
//import "react-bootstrap-toggle/dist/bootstrap2-toggle.css";
require('./favicon.ico'); // Tell webpack to load favicon.ico
const store = configureStore();

render(
  <AppContainer>
    <Root store={store} history={history} hostUrl={window.location.origin}/>
  </AppContainer>,
  document.getElementById('app')
);

if (module.hot) {
  module.hot.accept('./components/Root', () => {
    const NewRoot = require('./components/Root').default;
    render(
      <AppContainer>
        <NewRoot store={store} history={history} />
      </AppContainer>,
      document.getElementById('app')
    );
  });
}
